const apiConfig = {
   
    leela: {
        profile: "/api/v1/manager/profile",
        register_profile: "/api/v1/register/manager",
        register_company: "/api/v1/register/company",
        submit_company: "/api/v1/company/submit-for-approval",
        dashboard: "/api/v1/dashboard/jobs",
        job: "/api/v1/jobs/",
        candidate_view: "/api/v1/candidates/",
        active_subscription: "/api/v1/company/active-subscription",
        info: "/api/v1/company/info",
        company_industry: "/api/v1/public/general/company-industries",
        job_role: "/api/v1/job-roles",
        team_management: "/api/v1/user-management/company-managers"
    },
  
    base:{
        company: "/company",
        std_assessment: "/company/std-assessment",
        additional_assessment: "/room/additional-assessment",
        template_question: "/template/question",
        create_room: "/interview/create",
        generate_jd: "/generate-jd",
        generate_description: "/generate-description",
        room: "/interview",
        generate_question: "/question/generate",
        all_room: "/interview/all",
        send_email: "/email/interview/invite",
        candidate: "/candidate",
        credit_log: "/credits/log/search",
        report: "/report",
        interview_question: "/ai/interview-question",
         assessment_question: "/assessment/",
         update_user_management: "/company/user-management",
         get_user_management: "/company/users",
         add_user_to_job: "/users-management"
    },
    authen:{
        token: "/api/v2.0/oauth/token",
        profile: "/api/v2.0/manager/profile",
        refresh_token: "/api/v2.0/oauth/token"
    },
    resume:{
        summary: "/summary"
    },
    skills:{
        skill: "/skills",
    }
   

}


export default {
    // Add common config values here
    ...apiConfig
};